export { default as Theme} from './Theme';
